<template>
  <div class="notify-block">
    <div class="notify-head" :class="{ bordered: notifications.length == 0 }">
      <p>Новые уведомления</p>
      <router-link :to="{ name: 'EditProfile' }"
        ><div class="settings">Настройки</div></router-link
      >
    </div>
    <div class="notify-body">
      <template v-if="notifications.length != 0">
        <div
          v-for="item in notifications"
          :key="item.eventEntityId"
          class="notify-item"
        >
          <notify-item
            @viewEvent="$emit('updateViewed')"
            :item="item"
          ></notify-item>
        </div>
      </template>
      <template v-else style="text-align: center;">
        <div>
          <p
            style=""
            class="empty-text"
          >
            У вас нет новых уведомлений
          </p>
          <div style="text-align: center">
            <button-view
              class="alternative-btn"
              :color="'#006EFF'"
              :width="345"
              :height="45"
              @clickAction="$router.push({ name: 'NotifyList' })"
              >Показать все</button-view
            >
          </div>
        </div>
      </template>
    </div>
    <div class="notify-actions" v-if="notifications.length != 0">
      <el-row :gutter="20">
        <el-col :span="12">
          <button-view
            class="alternative-btn"
            :color="'#006EFF'"
            :width="165"
            :height="45"
            @clickAction="goToNotifyPage"
            >Показать все</button-view
          >
        </el-col>
        <el-col :span="12">
          <button-view
            class="alternative-btn"
            :color="'#006EFF'"
            :width="165"
            :height="45"
            @clickAction="readAll"
            >Прочитать все</button-view
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import buttonView from "@/components/Common/UI/buttonView.vue";
import notifyItem from "./notifyItem.vue";
import {mapGetters} from "vuex"; 
export default {
  components: {
    buttonView,
    notifyItem,
  },
  data() {
    return {
      notifications: [],
    };
  },
  computed:{
     ...mapGetters("context", ["currentUserId"]),
  },
  methods: {
    goToNotifyPage(){
      this.$router.push({ name: 'NotifyList' });
    },
    async getNotifications() {
      this.notifications = (
        await this.$http.get(
          "api/EventNotification?offset=1&limit=5&showViewed=false"
        )
      ).data;
    },
    async readAll() {
      await this.$http.put("api/EventNotification/SetViewedAll");
      this.$hub.updateNotifications(this.currentUserId);
      await this.getNotifications();
    },
  },
  created() {
    this.getNotifications();
  },
};
</script>
<style scoped>
.empty-text{
  color: var(--textGeneralColor);
  padding: 10px 0px 10px 0px;
  text-align: center
}
.bordered {
  border-bottom: 1px solid var(--blockBorder);
}
</style>
<style>
.notify-item a {
  border: none !important;
}
.notify-item {
  border-top: 1px solid var(--blockBorder);
  padding: 20px 15px 20px 15px;
}
.notify-actions {
  border-top: 1px solid var(--blockBorder);
  padding: 20px 15px 20px 15px;
}
.notify-body {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
}
.notify-head .settings {
  position: absolute;
  top: 0px;
  right: 0px;
  background: var(--btn-alternative-background);
  border-radius: 0px 5px;
  padding: 8px 20px 7px 20px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;

  text-align: center;

  color: var(--text-blue-button);
}
.notify-head {
  padding: 20px 15px 20px 15px;
}
.notify-head p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin: 0px;
  color: var(--textGeneralColor);
  text-align: left;
}
.parent-relative {
  position: relative;
  width: 20px;
}
.notify-block {
  position: absolute;
  top: 36px;
  min-height: 196px;
  max-height: 814px;
  width: 375px;
  left: -375px;
  background: var(--backgroundColor);
  box-shadow: 0px 4px 4px var(--box-shadow);
  border-radius: 5px;
}
</style>
